import LogoImage from 'assets/images/logo-icon.png';
import { aboutElixirLinks, categoryLinks, helpLinks, IFooterLink, socialMedia } from 'components/footer/configs';
import ImageResponsive from 'components/imageResponsive';
import { RouteBasePath } from 'components/mainLayout/routeBasePath';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const FooterNavigations: React.FC = () => {
  const { t } = useTranslation();

  const footerMenus = useMemo<Record<string, IFooterLink[]>>(
    () => ({
      'labels.about_elixir': aboutElixirLinks,
      'labels.help': helpLinks,
      'labels.menu_categories': categoryLinks
    }),
    []
  );

  return (
    <ul className='grid w-full grid-cols-2 gap-5 lg:grid-cols-4'>
      <li className='w-full px-4'>
        <div className='w-1/3'>
          <Link to={RouteBasePath.CLIENT_BASE_URL} className='relative block w-full overflow-hidden pb-100%'>
            <ImageResponsive src={LogoImage} />
          </Link>
        </div>
        <ul className='mt-5 flex flex-wrap items-center'>
          {socialMedia.map((social) => (
            <li key={social.link} className='mr-2 last:mr-0'>
              <a
                href={social.link}
                title={social.label}
                target='_blank'
                className='block h-8 w-8 rounded-md p-1 transition-all duration-300 ease-in-out hover:bg-hl-dark/90 hover:text-white'
                rel='noreferrer'
              >
                {React.cloneElement(social.icon, { className: 'w-full h-full' })}
              </a>
            </li>
          ))}
        </ul>
      </li>

      {Object.keys(footerMenus).map((key) => (
        <li key={key} className='w-full px-4'>
          <p className='relative pb-5 text-lg font-bold text-hl-dark after:absolute after:left-0 after:bottom-0 after:h-[1px] after:w-[30px] after:bg-hl-dark after:content-[""]'>
            {t(key)}
          </p>
          <ul className='mt-5'>
            {footerMenus[key as keyof typeof footerMenus].map((item) => (
              <li key={item.link} className='link'>
                <Link to={item.link} className='text-sm font-medium leading-8 text-hl-dark hover:text-hl-primary'>
                  {t(item.label)}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};
